import { List as RadixList, TabsListProps } from '@radix-ui/react-tabs';
import { twMerge } from 'tailwind-merge';

interface ListProps extends TabsListProps {}

function List({ className, children, ...props }: ListProps) {
  return (
    <div className={twMerge('border-b border-neutral-300', className)}>
      <RadixList role="tablist" className="-mx-3 flex flex-row gap-4" {...props}>
        {children}
      </RadixList>
    </div>
  );
}

export { List };
